import React, { useState, useEffect, useCallback, useRef } from "react";
import { Modal } from "antd";
import "./index.less";
import ToolsItem from "./ToolsItem";
import DragContent from "./DragContent";
import styles from "./index.module.less";
import ScrollView from "@/baseComponents/ScrollView";
import { PlusCircleFilled, MinusCircleFilled } from "@/utils/antdIcon";
import { ICardRes, ICard } from "../../interface";

const { confirm } = Modal;

export default function ModalAppTool({
  cards,
  isModalVisible,
  onCancel,
  onCardsOrderChange,
  onAddCard,
  onDeleteCard
}: {
  cards: ICardRes;
  isModalVisible: boolean;
  onCancel: () => void;
  onCardsOrderChange?: (newCards: ICard[]) => void;
  onAddCard?: (card: ICard) => void;
  onDeleteCard?: (card: ICard) => void;
}) {
  const scrollRef: any = useRef(null);

  const onReorder = useCallback(
    async (startIndex, endIndex) => {
      if (startIndex === endIndex) {
        return;
      }
      const newCards = [...cards.addedCards];
      // 删除并记录 删除元素
      const [removed] = newCards.splice(startIndex, 1);
      // 将原来的元素添加进数组
      newCards.splice(endIndex, 0, removed);
      onCardsOrderChange?.(newCards);
    },
    [cards, onCardsOrderChange]
  );
  const handleCancel = useCallback(() => {
    onCancel();
  }, [onCancel]);
  const addCard = useCallback(
    (item: ICard) => {
      onAddCard?.(item);
    },
    [onAddCard]
  );
  return (
    <Modal
      className={`app-tool-modal ${styles["app-tool-modal"]}`}
      bodyStyle={{ minHeight: 300, padding: 0 }}
      title="管理卡片"
      destroyOnClose={true}
      maskClosable={false}
      centered
      visible={isModalVisible}
      onCancel={handleCancel}
      footer={null}
    >
      <div className={styles["content"]}>
        <ScrollView ref={scrollRef} autoHide>
          <div className={styles["title"]}>已添加卡片</div>
          <div className={styles["app-tools-main"]}>
            <ToolsItem
              isDragging={false}
              toolsItem={{ type: "Tools", cardId: "tools", name: "全部应用", icon: "" }}
              isShowTopIcon={true}
              handleBtn={<MinusCircleFilled style={{ color: "#E6E6E6", cursor: "not-allowed" }} />}
            />
            <DragContent
              rightContentList={cards.addedCards}
              onReorder={onReorder}
              onDeleteCard={onDeleteCard}
            />
          </div>
          <div className={styles["title"]}>未添加卡片</div>
          <div>
            {cards?.remainingCards?.map((item: ICard) => {
              return (
                <ToolsItem
                  key={item.cardId}
                  isDragging={false}
                  toolsItem={item}
                  handleBtn={
                    <PlusCircleFilled style={{ color: "#306FDC" }} onClick={() => addCard(item)} />
                  }
                />
              );
            })}
          </div>
        </ScrollView>
      </div>
    </Modal>
  );
}
